import React from "react";
import {
  Grid,
  Box,
  Typography,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import img from "../../assets/nw/cropped-Untitled-design-27.png";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import GavelIcon from "@mui/icons-material/Gavel";
import HandshakeIcon from "@mui/icons-material/Handshake";
import HomeWorkIcon from "@mui/icons-material/HomeWork";

const steps = [
  {
    icon: <VerifiedUserIcon sx={{ fontSize: 36, color: "#05455c" }} />,
    title: "TRUSTED ORGANIZATION",
    description:
      "Nava Karnataka Nirmana & Others Housing Welfare Trust is built on transparency and credibility.",
  },
  {
    icon: <AccountBalanceIcon sx={{ fontSize: 36, color: "#05455c" }} />,
    title: "SAFE TRANSACTIONS",
    description:
      "We only accept payments via cheques, money orders, RTGS, NEFT, and verified electronic transfers.",
  },
  {
    icon: <GavelIcon sx={{ fontSize: 36, color: "#05455c" }} />,
    title: "LEGAL COMPLIANCE",
    description:
      "All operations are carried out under legal frameworks to protect our members’ interests.",
  },
  {
    icon: <HandshakeIcon sx={{ fontSize: 36, color: "#05455c" }} />,
    title: "MEMBER COMMITMENT",
    description:
      "We value our members’ trust and ensure complete support throughout their journey.",
  },
];

const Trataka = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box sx={{ maxWidth: "1100px", mx: "auto", py: 4 }}>
      <Grid container spacing={6} alignItems="center">
        {/* Image Section with shiny glass hover */}
        {/* <Typography
          variant="h4"
          sx={{
            textAlign: "center",
            fontWeight: 700,
            color: "#62bb40",
            pt:8,
            fontFamily: "Georgia, serif",
          }}
        >
          NAVA KARNATAKA NIRMANA AND OTHERS HOUSING WELFARE TRUST
        </Typography> */}
        <Grid item xs={12} md={6.5}>
          <Box
            sx={{
              position: "relative",
              overflow: "hidden",
              cursor: "pointer",
              "&:hover .shiny": {
                animation: "shinyMove 0.2s linear forwards",
              },
              ".shiny": {
                animation: "none",
              },
            }}
          >
            <Box
              component="img"
              src={img}
              alt="cropped-Untitled-design-27"
              sx={{
                width: isMobile ? "100%" : "95%",
                display: "block",
                height: isMobile ? "35vh" : "70vh",
              }}
            />
            {/* Shiny overlay */}
            <Box
              className="shiny"
              sx={{
                position: "absolute",
                top: 0,
                left: "-75%",
                height: "100%",
                width: "20%",
                background:
                  "linear-gradient(120deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0) 100%)",
                transform: "skewX(-25deg)",
                pointerEvents: "none",
              }}
            />
          </Box>
        </Grid>

        {/* Content Section */}
        <Grid item xs={12} md={5.5}>
          <Stack spacing={2}>
            {steps.map(({ icon, title, description }, idx) => (
              <Stack
                key={idx}
                direction="row"
                spacing={2}
                alignItems="flex-start"
                sx={{ borderBottom: "1px solid lightgrey", pb: 2 }}
              >
                <Box
                  sx={{
                    bgcolor: "#e7faf6",
                    borderRadius: 2,
                    p: 0.4,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: 56,
                    minHeight: 56,
                    color: "#05455c",
                  }}
                >
                  {icon}
                </Box>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: "bold", color: "#05455c" }}
                  >
                    {title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 0.5 }}
                  >
                    {description}
                  </Typography>
                </Box>
              </Stack>
            ))}
          </Stack>
        </Grid>
      </Grid>

      {/* Keyframes animation */}
      <style>
        {`
          @keyframes shinyMove {
            0% {
              left: -75%;
            }
            100% {
              left: 125%;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default Trataka;
